import { render, staticRenderFns } from "./NewsSearchChartColumn.vue?vue&type=template&id=5b1866ca"
import script from "./NewsSearchChartColumn.vue?vue&type=script&lang=js"
export * from "./NewsSearchChartColumn.vue?vue&type=script&lang=js"
import style0 from "./NewsSearchChartColumn.vue?vue&type=style&index=0&id=5b1866ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports